import axios from 'axios';

import { buildCreateCampaignPayload } from './campaignCreatePayload';
import { getArtistAuthHeaders } from './artistSession';

export function getSubmitCampaignErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    'Payment received but we could not submit your campaign. Please contact support.'
  );
}

export async function submitPaidCampaign({ campaignData, stripeSessionId, session = {} }) {
  const normalizedSessionId = stripeSessionId?.toString?.().trim?.() || '';
  if (!normalizedSessionId) {
    throw new Error('stripeSessionId is required to create a paid campaign');
  }

  const token = getArtistAuthHeaders().authorization;
  const payload = buildCreateCampaignPayload(campaignData, {
    stripeSessionId: normalizedSessionId,
    session,
  });

  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_URI}/artistCampaign/createCampaign`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { authorization: token } : {}),
      },
    }
  );

  return response.data;
}
